import CustomSelect from '../vendors/custom-select';
import $scrollTo from 'jquery.scrollto/jquery.scrollTo';

export default {
    init() {
        // JavaScript to be fired on all pages
        const menuBurger = document.querySelector('.btn-menu-burger');
        const body = document.querySelector('body');

        menuBurger.addEventListener('click', () => {
            body.classList.toggle('menu-mobile-open');
            return false;
        });

        this.initLanguageSelector ();
        this.initScrollToTop();
    },

    initLanguageSelector () {
        const langSelectors = document.querySelectorAll('.select-lang');
        langSelectors.forEach( (langItem) => {
            // console.log (langItem instanceof HTMLElement);

            const langSelect = new CustomSelect(langItem, (value) => {
                location.href = value;
            });
            langSelect.init();
        })

    },

    initScrollToTop() {
        const scrollToTop = document.querySelector('.scroll-top');
        const _body = document.querySelector('body');

        if (scrollToTop) {
            document.querySelector('.scroll-top').addEventListener('click', () => {
                _body.classList.add('scroll-to-top');
                $scrollTo(0, 800, {
                    onAfter: () => {
                        console.log ('reach Top');
                        _body.classList.remove('scroll-to-top');
                    }
                });
            });
        }
    },

    finalize() {

    },

    fadeIn(element, duration) {
        element.style.opacity = 0;
        element.style.display = "block";

        let start = performance.now();

        function animate(timestamp) {
            let elapsed = timestamp - start;
            element.style.opacity = elapsed / duration;

            if (elapsed < duration) {
                requestAnimationFrame(animate);
            } else {
                element.style.opacity = 1;
            }
        }

        requestAnimationFrame(animate);
    },

    fadeOut(element, duration) {
        let start = performance.now();

        function animate(timestamp) {
            let elapsed = timestamp - start;
            element.style.opacity = 1 - elapsed / duration;

            if (elapsed < duration) {
                requestAnimationFrame(animate);
            } else {
                element.style.opacity = 0;
                element.style.display = "none";
            }
        }

        requestAnimationFrame(animate);
    }

};
